import { ethers } from "ethers";
import { ACTIVE_CONTRACTS } from "../config/app.config";

import DexAbi from "../abis/DexRouter.json";
import TokenAbi from "../abis/Token.json";
import Erc20Abi from "../abis/ERC20.json";

// Generic by address so both SCN and CORE markets share the same factory.
export function getDexContract(address, signerOrProvider) {
  return new ethers.Contract(address, DexAbi, signerOrProvider);
}

export function getTokenContract(address, signerOrProvider) {
  return new ethers.Contract(address, TokenAbi, signerOrProvider);
}

export function getUsdtContract(signerOrProvider) {
  return new ethers.Contract(ACTIVE_CONTRACTS.usdt, Erc20Abi, signerOrProvider);
}
